import { useMemo } from 'react';
import { TicketType } from '@/api/constant';
import { emptyShoppingCart } from '@/api/registration';
import { useGroupCartQuery } from './useGroupCartQuery';
import { useGroupRegistrationQuery } from './useGroupRegistrationQuery';

export function useIsGroupEmptyRegisTypeInCart(eventId: string) {
  const { data: groupRegisData, isFetched: isLoadedGroupRegis } = useGroupRegistrationQuery(eventId);
  const attendeesIds = (groupRegisData?.tempRegistrations ?? []).map((regis) => {
    return regis.id;
  });
  const { data: shoppingCart = emptyShoppingCart, isFetched } =
    useGroupCartQuery(eventId);
  const isGroupEmptyMainTicketInCart = useMemo(() => {
    if (!isFetched) return;
    const hasMainTicket = (attendeesIds ?? []).every((id) => {
      const isHasAttendeeRegisType = shoppingCart.cartItems?.some((item) => {
        return (
          item.tempRegistrationIds?.includes(id) &&
          item.ticketType === TicketType.Main
        );
      });
      return isHasAttendeeRegisType;
    });
    return !hasMainTicket;
  }, [shoppingCart.cartItems, isFetched, isLoadedGroupRegis]);

  return { isGroupEmptyMainTicketInCart };
}
